import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_radio = _resolveComponent("el-radio");
  var _component_el_radio_group = _resolveComponent("el-radio-group");
  return _openBlock(), _createBlock(_component_el_radio_group, {
    "class": _normalizeClass($props.field.wrapper_class),
    modelValue: $data.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.model = $event;
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.field.options, function (item, itemIndex) {
        return _openBlock(), _createBlock(_component_el_radio, {
          key: itemIndex,
          label: item.id
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(_toDisplayString(item.label), 1 /* TEXT */)];
          }),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]);
      }), 128 /* KEYED_FRAGMENT */))];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "modelValue"]);
}